import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';

const AdminPanel = () => {
	const navigate = useNavigate();
	const { userProfile } = useAuth();
	const [stats, setStats] = useState({
		totalUsers: 0,
		customers: 0,
		employees: 0,
		admins: 0,
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchStats = async () => {
			try {
				const usersSnapshot = await getDocs(collection(db, 'users'));
				const users = usersSnapshot.docs.map((doc) => doc.data());

				setStats({
					totalUsers: users.length,
					customers: users.filter((u) => u.role === 'customer').length,
					employees: users.filter((u) => u.role === 'employee').length,
					admins: users.filter((u) => u.role === 'admin').length,
				});
			} catch (error) {
				console.error('Error fetching stats:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchStats();
	}, []);

	if (userProfile?.role !== 'admin') {
		return (
			<div className="container py-5">
				<wa-callout variant="danger">
					<strong>Access Denied</strong>
					<p className="mb-0 mt-2">You must be an administrator to access this page.</p>
				</wa-callout>
			</div>
		);
	}

	if (loading) {
		return (
			<div className="container py-5">
				<div className="text-center">
					<wa-spinner style={{ fontSize: '2rem' }}></wa-spinner>
				</div>
			</div>
		);
	}

	const statCards = [
		{ label: 'Total Users', value: stats.totalUsers, color: '#384971' },
		{ label: 'Customers', value: stats.customers, color: '#5b7bb3' },
		{ label: 'Employees', value: stats.employees, color: '#7a9fd4' },
		{ label: 'Admins', value: stats.admins, color: '#9fc3f5' },
	];

	return (
		<div className="container py-5">
			<h1 className="mb-4" style={{ color: '#384971' }}>
				Admin Panel
			</h1>
			<p className="text-muted mb-5">
				Manage users, roles, and system-wide settings.
			</p>

			{/* Stats Cards */}
			<div className="grid grid-cols-1 grid-cols-md-2 grid-cols-lg-4 gap-4 mb-5">
				{statCards.map((stat, idx) => (
					<wa-card key={idx} className="text-center">
						<div className="py-3">
							<h2 className="mb-2" style={{ fontSize: '3rem', color: stat.color }}>
								{stat.value}
							</h2>
							<p className="text-muted mb-0">{stat.label}</p>
						</div>
					</wa-card>
				))}
			</div>

			{/* Quick Actions & Activity */}
			<div className="grid grid-cols-1 grid-cols-lg-2 gap-4">
				<wa-card className="h-100">
					<div slot="header">
						<strong>Quick Actions</strong>
					</div>
					<div className="d-flex flex-column gap-2">
						<wa-button
							variant="default"
							outline
							className="w-100"
							onClick={() => navigate('/portal/work/staff-access')}>
							<i className="fa-sharp fa-solid fa-user-shield me-2"></i>
							Staff Access
						</wa-button>
						<wa-button variant="default" outline className="w-100">
							<i className="fa-sharp fa-solid fa-database me-2"></i>
							Backup Data
						</wa-button>
					</div>
				</wa-card>

				<wa-card className="h-100">
					<div slot="header">
						<strong>Recent Activity</strong>
					</div>
					<wa-callout variant="primary">
						Activity tracking coming soon...
					</wa-callout>
				</wa-card>
			</div>
		</div>
	);
};

export default AdminPanel;
